import { Pipe, PipeTransform } from '@angular/core';
import { ModifierPromptOption } from '../../models';

@Pipe({
  name: 'isOptionSelectedPipe'
})
export class IsOptionSelectedPipe implements PipeTransform {
  transform(
    option: ModifierPromptOption,
    selectedOptions?: ModifierPromptOption[]
  ): boolean {
    return selectedOptions?.some((x) => x.id === option.id) || false;
  }
}
